/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Wishlist methods
 * -----------------------------------------------------------------------------
 *
 * @namespace wishlist
 */

import axios from 'axios';

var wishlistMethods = {
  data: function data() {
    return {
      wishlist: []
    };
  },


  methods: {
    _initWishlist: function _initWishlist() {
      app._getWishlist();
    },


    /**
     * Gets the wishlist Array from Local localStorage
     */
    _getWishlist: function _getWishlist() {
      var wishlist = localStorage.getItem('user_wishlist');
      if (!wishlist) {
        return;
      }

      // set data
      app.wishlist = JSON.parse(wishlist);
    },


    /**
     * Checks if a variant exists in the wishlist
     * @param  {variant}
     * @return {boolean}
     */
    _checkWishlist: function _checkWishlist(variant) {
      var index = this.wishlist.findIndex(function (x) {
        return x.id === variant;
      });

      if (index === -1) {
        return false;
      }
      return true;
    },


    /**
     * Adds the selected variant in wishlist Array
     * @param  {productHandle, variantId}
     *
     */
    _addVariantToWishlist: function _addVariantToWishlist(productHandle, variantId, event) {
      var defaultVariantId = $(event.currentTarget).data('default-variant-id');
      variantId = variantId || defaultVariantId;
      var index = app.wishlist.findIndex(function (x) {
        return x.id === variantId;
      });

      // push object to wishlist Array only if it doesn't exists
      if (index === -1) {
        app.isLoading = true;

        axios.get("/products/" + productHandle + ".js").then(function (response) {
          app.isLoading = false;

          var currentVariant = response.data.variants.filter(function (x) {
            return x.id === variantId;
          })[0];

          // add additional properties to the object
          currentVariant.product_handle = productHandle;

          // default image
          if (currentVariant.option1 === 'Default Title' || currentVariant.featured_image === null) {
            currentVariant.featured_image = response.data.featured_image;
          }

          app.wishlist.push(currentVariant);
          localStorage.setItem('user_wishlist', JSON.stringify(app.wishlist));
          $('[data-toggle="tooltip"]').tooltip('hide');
          return response;
        }).catch(function (error) {
          // console.log(error);
          throw error;
        });
      }
    },


    /**
     * Adds a variant from wishlist Array
     * @param  {variantId}
     *
     */
    _removeFromWishlist: function _removeFromWishlist(variantId) {
      var index = app.wishlist.findIndex(function (x) {
        return x.id === variantId;
      });

      if (index > -1) {
        app.wishlist.splice(index, 1);
        localStorage.setItem('user_wishlist', JSON.stringify(app.wishlist));
      }
    },


    /**
     * Returns the variant Url from a given variant Id
     * @param  {productHandle, variantId}
     * @return {string}
     *
     */
    _getvariantUrl: function _getvariantUrl(productHandle, variantId) {
      return "/products/" + productHandle + "?variant=" + variantId;
    }
  }
};

export default wishlistMethods;